import React from 'react';

import styled from 'styled-components';

export const Skeleton = () => (
    <SkeletonRoot>
        <tbody>
            {Array.from({length: 15}, (val, index) => (
                <tr key={index}>
                    <td aria-hidden="true" />
                </tr>
            ))}
        </tbody>
    </SkeletonRoot>
);

const SkeletonRoot = styled.table`
    width: 100%;
    border-collapse: collapse;
    animation: fadeIn 1s;

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    td {
        height: 40px;
    }

    tr:nth-child(odd) {
        td {
            background: linear-gradient(-90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);
            background-size: 400% 400%;
            animation: pulse 1.2s ease-in-out infinite;

            @keyframes pulse {
                0% {
                    background-position: 0 0;
                }
                100% {
                    background-position: -135% 0;
                }
            }
        }
    }
`;
